package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2026_04_11_Day_1
import com.veldekar.components.logs.Log_2026_04_11_Day_2
import com.veldekar.components.logs.Log_2026_04_11_Day_3
import com.veldekar.components.widgets.SessionDayHeader
import com.veldekar.components.widgets.SessionMediaItem
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2026-04-11")
@Composable
public fun Log_2026_04_11(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Cardigan of Defense",
        ogTitle = "Cardigan of Defense",
        date = LocalDate(2_026, 4, 11),
        aiHint = "When Dirk said he takes cover “behind the cart again,” Caper misheard him saying “being the cardigan.” So the image show Dirk (from the campaign) hiding behind Fred Rogers (the host of a children's TV show in the real world known for wearing a cardigan). The title is a reference to this as well.",
        ogDescription = "The smoke is thick, the Balor is angry, and Bigglesworth is seconds away from inventing a new extreme sport. Even so, the heroes handle the crisis with the steady warmth of travelers who bring a little friendliness wherever they wander… even to a block currently full of giants.",
        ogImage = "images/cardiganOfDefenseSocial.webp",
        ogImageWidth = 1_195,
        ogImageHeight = 629,
        ogImageAlt = "PBS's Mr. Rogers in foreground. Dirk is hiding behind him, peeking out from behind his left shoulder.",
    ) {
        SessionDayHeader(dayId = "shimmer-22", dateString = "Shimmer 22", cardImageSrc = "images/cardiganOfDefenseSocial.webp", width = 1_195, height = 629)
        Log_2026_04_11_Day_1()
        SessionDayHeader(dayId = "shimmer-23", dateString = "Shimmer 23")
        Log_2026_04_11_Day_2()
        SessionDayHeader(dayId = "shimmer-25", dateString = "Shimmer 25")
        Log_2026_04_11_Day_3()
        SessionMediaItem(
            image = "images/cardiganOfDefense.webp",
            linkImage = "images/cardiganOfDefense.webp",
            description = "PBS's Mr. Rogers in foreground. Dirk is hiding behind him, peeking out from behind his left shoulder.",
            width = 1_200,
            height = 1_818,
        )
    }
}
